export default "<div class=\"grid\">\n  <img src=\"/assets/img/404.svg\">\n\n  <div>\n    <ng-content></ng-content>\n  </div>\n</div>\n";